<template>
    <div class="withdrawal-help-modal-sec">
        <div class="withdrawal-step2-modal modal fade" id="withdrawal-step2-modal" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="pop-upWithdrawalHelp-content_title">
                        <p class="para-two">Help</p>
                        <button class="btn-close1" data-bs-dismiss="modal">
                            <img src="@/assets/images/cross-icon.webp" alt="cross-icon">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="pop-upWithdrawalHelp-content">
                            <div class="pop-upWithdrawalHelp-content_title-big">Step 2</div>
                            <div><img loading="lazy" src="@/assets/images/Step2Withdrawal.webp" alt="Step2Withdrawal"></div>
                            <div class="withdrawal-btn text-center">
                                <button class="btn btn-primary next" data-bs-toggle="modal"
                                    data-bs-target="#withdrawal-step2-modal" data-bs-dismiss="modal">Got It</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="withdrawal-help-modal-sec">
        <div class="withdrawal-help-modal modal fade" id="withdrawal-help-modal" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false"> 
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="pop-upWithdrawalHelp-content_title">
                        <p class="para-two">Help</p>
                        <button class="btn-close1" data-bs-dismiss="modal"> 
                            <img src="@/assets/images/cross-icon.webp" alt="cross-icon">
                        </button>
                    </div>
                    
                    <div class="modal-body">
                        <div class="pop-upWithdrawalHelp-content">
                            <div class="pop-upWithdrawalHelp-content_title-big">Step 1</div>
                            <div class="pop-upWithdrawalHelp-content_title-desc">1. Enter Amount to be withdrawn.</div>
                            <div class="pop-upWithdrawalHelp-content_title-desc">2. Enter you Account no and IFSC
                                details.</div>
                            <div class="pop-upWithdrawalHelp-content_title-desc">3.Click submit button.</div>
                            <div><img loading="lazy" src="@/assets/images/Step1Withdrawal.webp" alt="Step1Withdrawal"></div>
                            <div class="withdrawal-btn text-center">
                                <button class="btn btn-primary next" data-bs-toggle="modal"
                                    data-bs-target="#withdrawal-step2-modal" data-bs-dismiss="modal">
                                    <span>Next</span>
                                    <span><i class="fa-solid fa-arrow-right"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    name:'HelpModal'
}
</script>